var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('h6',[_vm._v("Pagamento via:")]),_c('img',{attrs:{"src":require("@/assets/images/logo-getnet.jpg")}})])
}]

export { render, staticRenderFns }